import { CallApiOptions } from './api';
import { FeaturedCluster } from '../store/Entities/FeaturedCluster/featured-cluster.reducer';
import * as R from 'ramda';
import { Cluster } from '../store/Entities/Clusters/clusters.reducer';

export interface ApiFeaturedCluster {
  app_id: number;
  gender: string;
  cluster_id: number;
  position: number;
  id: number;
  active_from: string | null;
  active_to: string | null;
  cluster?: Cluster;
}

export const fetchFeaturedClustersCallOptions = (): CallApiOptions => ({
  method: 'GET',
  endpoint: 'featured-clusters',
});

export const saveFeaturedClustersCallOptions = (
  data: FeaturedCluster[]
): CallApiOptions => {
  return {
    method: 'POST',
    endpoint: 'featured-clusters',
    body: JSON.stringify({
      featured_clusters: mapFeaturedClusters(data),
    }),
  };
};

export const removeFeaturedClusterCallOptions = (
  id: number
): CallApiOptions => {
  return {
    method: 'DELETE',
    endpoint: `featured-clusters/${id}`,
  };
};

export function mapFeaturedClusters(
  data: FeaturedCluster[]
): ApiFeaturedCluster[] {
  return R.map((item: FeaturedCluster) => {
    return {
      app_id: item.appId,
      gender: item.gender,
      cluster_id: item.clusterId,
      position: item.position,
      id: item.id,
      active_from: item.activeFrom,
      active_to: item.activeTo,
      cluster: item.cluster,
    };
  }, data);
}



// WEBPACK FOOTER //
// ./src/services/featured-cluster.services.ts